import type { AnnotationEntry } from '@geosoft/viewer-sdk';
import { formatDistanceMeters, haversineMeters } from '@/components/plugins/geo';

export interface ProfileSummary {
  readonly status: 'ready' | 'pending' | 'no route';
  readonly label: string;
  readonly distanceLabel: string;
  readonly sampleCount: number;
}

export function summarizeProfile(annotations: ReadonlyArray<AnnotationEntry>): ProfileSummary {
  const crossSection = annotations.find(
    (annotation) =>
      annotation.kind === 'geo:cross-section-line' && annotation.geometry.type === 'LineString',
  );

  if (!crossSection || crossSection.geometry.type !== 'LineString') {
    return {
      status: 'no route',
      label: 'draw a cross-section line',
      distanceLabel: 'n/a',
      sampleCount: 0,
    };
  }

  const coordinates = crossSection.geometry.coordinates as Array<[number, number]>;
  const [start, end] = coordinates;
  return {
    status: 'ready',
    label: String(crossSection.properties.label ?? 'Cross-section profile'),
    distanceLabel: start && end ? formatDistanceMeters(haversineMeters(start, end)) : 'n/a',
    sampleCount: Number(crossSection.properties.sampleCount ?? 32),
  };
}
